<form [formGroup]="searchForm">
        <ng-container *ngIf="filterField">
            <mat-form-field class="w-full">
                <input type="text" placeholder="Search Field" aria-label="Number" matInput formControlName="FieldName"
                    [matAutocomplete]="fieldName" />

                <mat-autocomplete #fieldName="matAutocomplete">
                    <mat-option *ngFor="let row of options.fields" [value]="row.fieldLongName">
                        {{ row.fieldLongName }} <br /><small>({{ row.fieldShortName }})</small>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </ng-container>
        <div *ngIf="filterPlatform">
            <mat-form-field class="w-full">
                <input type="text" placeholder="Search Platform" aria-label="Number" matInput
                    formControlName="PlatformName" [matAutocomplete]="platformName" />
                <mat-autocomplete #platformName="matAutocomplete">
                    <mat-option *ngFor="let row of options.platforms" [value]="row.platformLongName">
                        {{ row.platformLongName }} <br /><small>({{ row.platformShortName }})</small>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>

        <div *ngIf="filterWell">
            <mat-form-field class="w-full">
                <input type="text" placeholder="Search Well" aria-label="Number" matInput formControlName="WellName"
                    [matAutocomplete]="wellName" />
                <mat-autocomplete #wellName="matAutocomplete">
                    <mat-option *ngFor="let row of options.wells" [value]="row.wellLongName">
                        {{ row.wellLongName }} <br /><small>({{ row.wellShortName }})</small>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>

        <div *ngIf="filterString">
            <mat-form-field class="w-full">
                <input type="text" placeholder="Search String" aria-label="Number" matInput formControlName="StringName"
                    [matAutocomplete]="stringName" />
                <mat-autocomplete #stringName="matAutocomplete">
                    <mat-option *ngFor="let row of options.wellStrings" [value]="row.stringLongName">
                        {{ row.stringLongName }} <br /><small>({{ row.stringShortName }})</small>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
</form>